import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StudentNote } from '../../../classroom360/student-notes/student-note.model';

@Component({
  selector: 'app-student-notes-popup',
  templateUrl: './student-notes-popup.component.html',
  styleUrls: ['./student-notes-popup.component.css']
})
export class StudentNotesPopupComponent implements OnInit {

  notes: StudentNote[];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialogRef<StudentNotesPopupComponent>,
  ) {
    this.notes = data;
   }

  ngOnInit() {
  }

  closeClick() {
    this.dialog.close();
  }

}
